import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M11.207 6.25H9.75V1.667A.92.92 0 0 0 8.833.75H5.167a.92.92 0 0 0-.917.917V6.25H2.792c-.815 0-1.228.99-.65 1.567l4.207 4.208a.913.913 0 0 0 1.293 0l4.207-4.208c.578-.577.174-1.567-.642-1.567ZM.583 15.417a.92.92 0 0 0 .917.916h11a.92.92 0 0 0 .917-.916.92.92 0 0 0-.917-.917h-11a.92.92 0 0 0-.917.917Z",
  fill: "#1E92EF"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };